import { useCallback, useRef } from "react";

export default function useDelay() {
	const timer = useRef();
	const stop = useCallback(() => {
		const cur = timer.current;
		if (!cur) return;
		clearTimeout(cur);
	}, []);
	const start = useCallback((fn, d, ...args) => {
		stop();
		timer.current = setTimeout(fn, d, ...args);
	}, []);
	return [start, stop];
}